import { render, staticRenderFns } from "./modal-historia.vue?vue&type=template&id=7c3a36b3&scoped=true&"
import script from "./modal-historia.vue?vue&type=script&lang=js&"
export * from "./modal-historia.vue?vue&type=script&lang=js&"
import style0 from "./modal-historia.vue?vue&type=style&index=0&id=7c3a36b3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3a36b3",
  null
  
)

export default component.exports